import axios from 'axios'

const PAYMENT_SERVER_ADDRESS = "https://pay.ems-a.com"


export function makePayment(
    card_encrypted,
    card_holder_name,
    email,
    documentNumber,
    package_number,
    sensor_unique_code,
){
    documentNumber = documentNumber.replace(/\D/g, '');
    const url = `${PAYMENT_SERVER_ADDRESS}/v1/payment/alert/${package_number}/credit-card/order` 
    const payload = {
        "sensor_unique_code": sensor_unique_code,
        "customer": {
            "name": card_holder_name,
            "email": email,
            "tax_id": documentNumber
        },
        "card_info": {
            "holder_name": card_holder_name,
            "encrypted": card_encrypted
        }
    }
    console.log("Payload de pagamento: ", payload)
    return axios({
        method: 'POST',
        url: url,
        data: payload,
    })
}
